import React from 'react';
import { Layers, Package, Maximize2, Percent, Grid3x3 } from 'lucide-react';

const CuttingPlanSummary = ({ plan, boards = [], positions = [] }) => {
  const totalPieces = positions.length || plan.total_pieces || 0;
  const totalSheets = boards.length || plan.total_sheets || 0;
  const totalArea = boards.reduce((sum, b) => sum + (parseFloat(b.total_area) || 0), 0);
  const usedArea = boards.reduce((sum, b) => sum + (parseFloat(b.used_area) || 0), 0);
  const efficiency = totalArea > 0 ? ((usedArea / totalArea) * 100).toFixed(1) : (plan.efficiency_percentage || 0);

  const stats = [
    {
      label: 'Total de Peças',
      value: totalPieces,
      icon: Package,
      color: 'bg-blue-50 text-blue-600'
    },
    {
      label: 'Chapas',
      value: totalSheets,
      icon: Grid3x3,
      color: 'bg-green-50 text-green-600'
    },
    {
      label: 'Área Total',
      value: `${totalArea.toFixed(3)} m²`,
      icon: Maximize2,
      color: 'bg-purple-50 text-purple-600'
    },
    {
      label: 'Aproveitamento',
      value: `${efficiency}%`,
      icon: Percent,
      color: efficiency >= 70 ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'
    }
  ];

  const boardSizes = [...new Set(boards.map(b => `${b.width}x${b.height}`))];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Resumo do Plano</h2>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {stats.map((stat) => (
          <div key={stat.label} className="flex items-center gap-3">
            <div className={`p-3 rounded-lg ${stat.color}`}>
              <stat.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              <p className="text-sm text-gray-500">{stat.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
        <div>
          <p className="text-sm text-gray-500">Dimensões da Chapa</p>
          <p className="text-lg font-medium text-gray-900">
            {plan.board_width}x{plan.board_height}m
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Kerf</p>
          <p className="text-lg font-medium text-gray-900">{plan.kerf_width}mm</p>
        </div>
        {boardSizes.length > 0 && (
          <div className="col-span-2">
            <p className="text-sm text-gray-500">Tamanhos de Chapa Utilizados</p>
            <div className="flex flex-wrap gap-2 mt-1">
              {boardSizes.map((size, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center px-2 py-1 bg-gray-100 text-gray-700 text-sm rounded"
                >
                  {size}mm
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CuttingPlanSummary;
